/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MantineProvider, createTheme } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Nucleus WebSocket registration - must be imported before any Nucleus code
import './nucleus';

// Mantine CSS imports - required for styles to work
import '@mantine/core/styles.css';

import { RouterBreadcrumbs, NestedRouter } from 'src/router';
import { OmniverseConfigProvider } from './providers';
import { omniverseRoutes } from './routes';
import { HttpError } from './util/Errors';

// Mantine theme configuration for Omniverse
const omniverseTheme = createTheme({
  fontFamily: 'Open Sans, sans-serif',
  colors: {
    green: [
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
    ],
  },
  white: '#fff',
  headings: {
    sizes: {
      h1: {
        fontSize: '48px',
      },
      h2: {
        fontSize: '20px',
      },
    },
    fontWeight: '200',
  },
});

// Query client with retry logic
const omniverseQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: Error) => {
        if (failureCount >= 5 && error instanceof HttpError) {
          if (error.status === 401) {
            // Redirect to login on auth failure
            window.location.href = '/login';
            return false;
          }
        }
        return failureCount < 5;
      },
    },
  },
});

/**
 * Main Omniverse Portal component.
 * Wrap this component with your authentication provider if needed.
 */
export default function OmniversePortal() {
  return (
    <QueryClientProvider client={omniverseQueryClient}>
      <MantineProvider theme={omniverseTheme} forceColorScheme={'light'}>
        <OmniverseConfigProvider>
          <OmniverseRoutes />
        </OmniverseConfigProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
}

/**
 * Omniverse internal routes.
 * Base path: /omniverse
 */
function OmniverseRoutes() {
  return (
    <>
      <RouterBreadcrumbs routes={omniverseRoutes} />
      <NestedRouter routes={omniverseRoutes} />
    </>
  );
}

// Export individual components for flexibility
export * from './components';
export * from './hooks';
export * from './pages';
export * from './providers';
export * from './state';
